import { Outlet} from "react-router-dom"
import WorkQueuesHeader from "../components/work_queues/header/WorkQueuesHeader"
import CheckWorkQSlug from "./CheckWorkQSlug"
import NoWorkQHeader from "../components/work_queues/header/NoWorkQHeader"


export default function WorkQueueLayout({noWorkQ}) {

    return <div>
        <CheckWorkQSlug />
        {!noWorkQ && <WorkQueuesHeader />}
        {noWorkQ && <NoWorkQHeader />}
        <Outlet />
    </div>
}